import React from 'react';
import { ChatMessage as ChatMessageType } from '@/types/aiChat';

interface ChatMessageProps {
  message: ChatMessageType;
  isStreaming?: boolean;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message, isStreaming = false }) => {
  const isUser = message.message_type === 'user';
  const isSystem = message.message_type === 'system';

  // 系统消息样式
  if (isSystem) {
    return (
      <div className="flex justify-center">
        <div className="bg-gray-100 text-gray-600 text-xs px-3 py-1 rounded-full max-w-sm text-center">
          {message.content}
        </div>
      </div>
    );
  }

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} items-start space-x-2`}>
      {/* AI头像 */}
      {!isUser && (
        <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs font-medium flex-shrink-0">
          大白
        </div>
      )}

      <div className={`max-w-sm ${isUser ? 'order-last' : ''}`}>
        {/* 消息气泡 */}
        <div
          className={`px-3 py-2 rounded-lg ${
            isUser
              ? 'bg-blue-600 text-white ml-auto'
              : 'bg-gray-100 text-gray-800'
          }`}
        >
          <p className="text-sm whitespace-pre-wrap">
            {message.content}
            {isStreaming && !isUser && (
              <span className="inline-block w-2 h-4 bg-blue-600 ml-1 animate-pulse" />
            )}
          </p>
        </div>

        {/* 消息元信息 */}
        <div className={`mt-1 text-xs text-gray-500 ${isUser ? 'text-right' : 'text-left'}`}>
          <span>{new Date(message.created_at).toLocaleTimeString()}</span>

          {/* AI消息的处理时间 */}
          {!isUser && message.processing_time_ms && (
            <span className="ml-2">
              · {message.processing_time_ms}ms
            </span>
          )}

          {/* AI模型信息 */}
          {!isUser && message.llm_provider && (
            <span className="ml-2">
              · {message.llm_provider}
            </span>
          )}
        </div>

        {/* 知识来源 */}
        {!isUser && message.sources && message.sources.length > 0 && (
          <div className="mt-2 space-y-1">
            <div className="text-xs text-gray-500">参考资料：</div>
            {message.sources.slice(0, 3).map((source, index) => (
              <div
                key={index}
                className="bg-blue-50 border border-blue-200 rounded p-2 text-xs"
              >
                <div className="font-medium text-blue-800 mb-1">
                  {source.title}
                  <span className="ml-1 text-blue-600">
                    ({Math.round(source.relevance * 100)}% 相关)
                  </span>
                </div>
                {source.content && (
                  <div className="text-gray-600 text-xs line-clamp-2">
                    {source.content.length > 100
                      ? `${source.content.substring(0, 100)}...`
                      : source.content
                    }
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Token使用统计（开发模式下显示） */}
        {!isUser && message.token_count && process.env.NODE_ENV === 'development' && (
          <div className="mt-1 text-xs text-gray-400">
            Tokens: {message.token_count.input_tokens}→{message.token_count.output_tokens}
            (总计: {message.token_count.total_tokens})
          </div>
        )}
      </div>

      {/* 用户头像 */}
      {isUser && (
        <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 text-sm font-medium flex-shrink-0">
          U
        </div>
      )}
    </div>
  );
};